import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'ManuSubManuUserAccess/Select');
};

export const UpdateAccessPermission = async (request) => {
    return PostAPI(request, 'ManuSubManuUserAccess/UpdateAccessData');
};

export const Update = async (request) => {
    return PostAPI(request, 'ManuSubManuUserAccess/Update');
};
